export enum ArticleCategoryEnum {
  Product = 'プロダクト',
  Tech = '技術',
  Creator = 'クリエイター',
}

export enum ArticleTypeEnum {
  NewFunction = '新機能',
  Renew = 'リニューアル',
  Improvement = '改善',
  MileStone = 'マイルストーン',
  MajorUpdate = 'メジャーアップデート',
  ForCreator = 'クリエイター向け',
}

export interface ArticleType {
  id: string;
  title: string;
  excerpt: string;
  category: ArticleCategoryEnum;
  type: ArticleTypeEnum;
  date: string;
  thumbnail: string;
  href: string;
}

export interface ArticleWithContentType extends ArticleType {
  content: string;
  metadata: {
    title: string;
    description: string;
    image: string;
    url: string;
    keywords: string;
  };
  readTime: string;
  author: {
    name: string;
    avatar: string;
    jobTitle: string;
  };
  breadcrumbItems: {
    label: string;
    href?: string;
  }[];
}

export interface IndexPageType {
  highlight: ArticleType & {
    imageHeight: number;
    imageWidth: number;
  };
  articles: ArticleType[];
}
